// src/hooks/useAuth.ts
import { useAppDispatch } from '../store/hooks'
import { logout as logoutAction } from '../store/slices/authSlice'
import { authApi } from '../services/authApi'

export const useAuth = () => {
  const dispatch = useAppDispatch()

  const logout = () => {
    // Clear RTK Query cache first to prevent any lingering queries
    dispatch(authApi.util.resetApiState())

    // Clear local storage
    localStorage.clear() // Clear all storage to ensure no lingering state

    // Dispatch logout to clear auth state
    dispatch(logoutAction())
  }

  const logoutAndNavigate = () => {
    logout()
    // Navigate to login page
    window.location.href = '/login'
  }

  return { logout, logoutAndNavigate }
}
